/**
 * Uzun sonuç listelerinde DOM düğümü sayısını düşürmek için react-window List (v2 API).
 * Kısa listelerde doğrudan map (ek yük yok).
 */
import { List } from 'react-window';
import { useLayoutEffect, useState } from 'preact/hooks';

function readPortalListViewportSize() {
  if (typeof window === 'undefined') {
    return { width: 900, height: 560 };
  }
  const w = Math.max(280, Math.floor(window.innerWidth - 48));
  const h = Math.max(360, Math.min(Math.floor(window.innerHeight * 0.62), 920));
  return { width: w, height: h };
}

/** Bu sayıdan fazla kayıtta sanal liste devreye girer */
export const PORTAL_LIST_VIRTUALIZE_MIN = 14;

export const PORTAL_QUERY_ROW_HEIGHT = 252;
export const PORTAL_LISTING_ROW_HEIGHT = 268;

function usePortalListViewportSize() {
  const [size, setSize] = useState(readPortalListViewportSize);

  useLayoutEffect(() => {
    const calc = () => {
      if (typeof window === 'undefined') return;
      const next = readPortalListViewportSize();
      setSize((prev) =>
        prev.width === next.width && prev.height === next.height ? prev : next,
      );
    };
    calc();
    window.addEventListener('resize', calc);
    return () => window.removeEventListener('resize', calc);
  }, []);

  return size;
}

function VirtualRow(props) {
  const { index, style, ariaAttributes, items, renderRow } = props;
  const item = items[index];
  if (!item) return null;
  return (
    <div
      style={{
        ...style,
        boxSizing: 'border-box',
        paddingBottom: 8,
      }}
      {...ariaAttributes}
    >
      {renderRow({ item, index })}
    </div>
  );
}

/**
 * @param {'query'|'listing'} kind
 * @param {Array} items
 * @param {(args: { item: any, index: number }) => import('preact').VNode} renderRow
 */
export function PortalRecentQueriesVirtualList({ kind, items, renderRow }) {
  const { width, height } = usePortalListViewportSize();
  const rowHeight = kind === 'listing' ? PORTAL_LISTING_ROW_HEIGHT : PORTAL_QUERY_ROW_HEIGHT;

  if (!items.length) return null;

  if (items.length < PORTAL_LIST_VIRTUALIZE_MIN) {
    return (
      <div className="pp-portal-results-list">
        {items.map((item, index) => renderRow({ item, index }))}
      </div>
    );
  }

  return (
    <div className="pp-portal-results-list pp-portal-results-list--virtual">
      <List
        rowCount={items.length}
        rowHeight={rowHeight}
        rowComponent={VirtualRow}
        rowProps={{ items, renderRow }}
        overscanCount={4}
        style={{
          height,
          width: '100%',
          maxWidth: width,
        }}
      />
    </div>
  );
}
